export default __webpack_public_path__ + "static/media/report.1feb16e9.svg";